import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

// The laptop's replenish screen is gone (Fernando 1.11: the walking device is always a cart tablet). The old link
// /inbounds/:id/replenish lands on the inbound, whose page shows what is ready, what is on which cart and the
// manager's "return its boxes". The walk itself is TabletTrip on the cart tablet. -- Claude, 2026-11-01
export default function InboundReplenish() {
  const { id = '' } = useParams<{ id: string }>();
  return <Navigate to={`/inbounds/${id}`} replace />;
}
